import PropTypes from 'prop-types';

import { Trans } from '@/components/tools/translation';

const TableError = ({ mutate }) => {
    return (
        <div className="flex min-h-[400px] items-center justify-center">
            <p>
                <Trans
                    i18nKey="errors:error_server_occurred"
                    components={{
                        tag0: <button className="underline" onClick={() => mutate(null)} />
                    }}
                />
            </p>
        </div>
    );
};

TableError.propTypes = {
    mutate: PropTypes.func
};

export default TableError;
